// extracted by mini-css-extract-plugin
export default {"main":"C49i-","container":"_066d-","title":"Fo7V6","titleThin":"_51kZF","exploreStays":"_1LPTQ","video":"pFBfd","subtitle":"t9xmk","button":"JyvGG","skeleton-progress":"tDxSV"};